
// require("gun/lib/then.js")
import Gun from 'gun'
require('gun/sea')
require('gun/lib/path.js')
// require('gun/lib/then')
var gun = Gun([ process.env.VUE_APP_GUN_SERVER + "/gun"]);

export default gun